<template>
    <div class="add_payment">
        <el-popover placement="right" width="348" trigger="manual" :visible-arrow="false" v-model="show"
                    @after-leave="show=false" popper-class="child_popover add_payment_popover">
            <div class="content">
                <div class="header">
                    <div class="icon" @click="show=false">
                        <img class="default" src="../../../assets/img/del.png" alt="">
                        <img class="hover" src="../../../assets/img/del_hover.png" alt="">
                    </div>
                    <h4>添加拨付资金</h4>
                </div>
                <el-form :model="ruleFormChild" :rules="rulesChild" ref="ruleFormChild" label-width="88px"
                         class="child_form add_payment_form">
                    <div class="label_left">
                        <el-form-item label="拨付类型" prop="type">
                            <el-select size="small" v-model="ruleFormChild.type"
                                       popper-class="global_select_popper allocate_type_select_popper"
                                       filterable allow-create default-first-option reserve-keyword
                                       @change="handleTypeChange">
                                <el-option v-for="item in typeOptions" :key="item.value" :label="item.label"
                                           :value="item.value">
                                    <div class="allocate_type_option">
                                        <span class="option_label">{{ item.label }}</span>
                                        <i v-if="item.deletable" class="el-icon-delete option_delete" title="删除拨付类型"
                                           @click.stop.prevent="handleDeleteType(item)"></i>
                                    </div>
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="拨付金额" prop="app_money">
                            <el-input-number v-model="ruleFormChild.app_money" size="small" :step="1" :controls="false"
                                             placeholder="请输入拨付金额" v-number-input.float></el-input-number>
                            <div class="unit">万元</div>
                        </el-form-item>
                        <el-form-item label="拨付对象" prop="app_object">
                            <el-input v-model="ruleFormChild.app_object" size="small" placeholder="请填写拨付对象"></el-input>
                        </el-form-item>
                        <el-form-item label="拨付日期" prop="app_data">
                            <el-date-picker size="small" v-model="ruleFormChild.app_data" type="date"
                                            placeholder="请选择拨付日期" value-format="yyyy-MM-dd"
                                            :clearable="false"></el-date-picker>
                        </el-form-item>
                        <el-form-item label="备注" prop="remark">
                            <el-input v-model="ruleFormChild.remark" size="small" placeholder="请填写备注"></el-input>
                        </el-form-item>
                        <el-form-item class="file_box" label="附件" prop="app_file_ids">
                            <fileListComp :file_list="ruleFormChild.app_file_ids" @change="editNameBack" />
                            <div>
                                <el-button type="text" @click="updateFile">添加附件</el-button>
                            </div>
                        </el-form-item>
                    </div>
                    <div class="button">
                        <el-button class="button_78px" size="mini" type="primary" @click="submitForm">保存</el-button>
                    </div>
                </el-form>
            </div>
            <el-button slot="reference" type="text" @click="show = true">添加项目拨付款</el-button>
        </el-popover>
    </div>
</template>

<script>
import dingDisk from '@/utils/ding_disk';
import fileListComp from '@/components/file/index.vue'
import {
    ensureAllocateTypeList,
    getAllocateTypeOptions,
    getAllocateTypeItemById,
    getAllocateTypeItemByName,
    ensureAllocateTypeId,
    deleteAllocateType
} from '@/utils/allocate_type';

export default {
    components: {fileListComp},
    props: {
        parent_form: {
            type: Object,
            require: true
        },
        mark: {
            type: Boolean
        },
        all_invest_num: {}
    },
    data() {
        return {
            show: false,
            syncingType: false,
            typeOptions: getAllocateTypeOptions(),
            ruleFormChild: {
                type: '',
                allocate_info: null,
                app_money: undefined,
                app_object: '',
                app_data: '',
                remark: '',
                app_file_ids: []
            },
            rulesChild: {
                type: [{required: true, message: '请选择拨付类型', trigger: 'change'}],
                app_money: [{required: true, message: '请输入拨付金额', trigger: 'blur'}],
                app_object: [{required: true, message: '请填写拨付对象', trigger: 'blur'}],
                app_data: [{required: true, message: '请选择拨付日期', trigger: 'change'}],
            }
        };
    },
    methods: {
        async getTypeOptions(force = false) {
            let list = await ensureAllocateTypeList(force);
            this.typeOptions = getAllocateTypeOptions(list);
            if (this.ruleFormChild.type && !this.syncAllocateInfo(this.ruleFormChild.type)) {
                this.clearTypeSelection();
            }
        },
        // 同步当前选中的拨付类型详情，保证本地新增数据也能直接按 allocate_info 回显。
        syncAllocateInfo(value) {
            let current = getAllocateTypeItemById(value, this.typeOptions);
            this.ruleFormChild.allocate_info = current ? {
                id: current.value !== undefined ? current.value : current.id,
                name: current.label !== undefined ? current.label : current.name,
            } : null;
            return !!current;
        },
        clearTypeSelection() {
            this.ruleFormChild.type = '';
            this.ruleFormChild.allocate_info = null;
        },
        async handleTypeChange(value) {
            if (this.syncingType || value === undefined || value === null || value === '') {
                return;
            }
            if (getAllocateTypeItemById(value, this.typeOptions)) {
                this.syncAllocateInfo(value);
                return;
            }
            let currentByName = getAllocateTypeItemByName(value, this.typeOptions);
            if (currentByName) {
                this.ruleFormChild.type = currentByName.value;
                this.syncAllocateInfo(currentByName.value);
                return;
            }
            this.syncingType = true;
            try {
                let typeId = await ensureAllocateTypeId(value);
                await this.getTypeOptions();
                this.ruleFormChild.type = typeId;
                this.syncAllocateInfo(typeId);
                this.$message.success('拨付类型创建成功');
            } catch (error) {
                this.clearTypeSelection();
                this.$message.error('拨付类型创建失败，请重试');
            } finally {
                this.syncingType = false;
            }
        },
        async handleDeleteType(item) {
            if (this.syncingType || !item || item.value === undefined || item.value === null || item.value === '') {
                return;
            }
            const h = this.$createElement;
            this.$msgbox({
                title: '提示',
                message: h('p', null, `是否确认删除拨付类型${item.label}？`),
                showCancelButton: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                beforeClose: async (action, instance, done) => {
                    if (action !== 'confirm') {
                        done();
                        return;
                    }
                    this.syncingType = true;
                    try {
                        let isCurrentType = String(this.ruleFormChild.type) === String(item.value);
                        await deleteAllocateType(item.value);
                        if (isCurrentType) {
                            this.clearTypeSelection();
                        }
                        await this.getTypeOptions(true);
                        this.$message.success('拨付类型删除成功');
                        done();
                    } catch (error) {
                        this.$message.error('拨付类型删除失败，请重试');
                    } finally {
                        this.syncingType = false;
                    }
                }
            }).catch(() => {

            });
        },
        submitForm() {
            this.$refs.ruleFormChild.validate((valid) => {
                if (valid) {
                    //项目拨付资金返回母组件方法
                    let appBack = () => {
                        this.$emit('addApp',JSON.parse(JSON.stringify(this.ruleFormChild)))
                        let payment = this.parent_form.payment || [];
                        payment.splice(0, 0, JSON.parse(JSON.stringify(this.ruleFormChild)));
                        this.show = false;
                    };
                    if (this.all_invest_num && this.ruleFormChild.app_money > this.all_invest_num) {
                        this.$message.error(`您录入的拨付金额已超出项目总投资金额${this.all_invest_num}万元！`);
                        return;
                    }
                    if (this.ruleFormChild.app_money > 1000) {
                        const h = this.$createElement;
                        this.$msgbox({
                            title: '提示',
                            message: h('p', null, `您录入的金额过大，请确认录入金额是否为 ${this.ruleFormChild.app_money} 万元`),
                            showCancelButton: true,
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            beforeClose: (action, instance, done) => {
                                if (action === 'confirm') {
                                    appBack();
                                    done();
                                } else {
                                    done();
                                }
                            }
                        }).catch(() => {

                        });
                    } else {
                        appBack();
                    }
                }
            });
        },
        //上传附件
        updateFile() {
            dingDisk.dingDiskUpdate(res => {
                this.ruleFormChild.app_file_ids = [...this.ruleFormChild.app_file_ids, ...res.data];
            });
        },
        //预览附件
        previewFile(file_info) {
            dingDisk.previewFile(file_info);
        },
        //修改名称后的附件数组
        editNameBack(file_list) {
            this.ruleFormChild.app_file_ids = file_list;
        },
    },
    watch: {
        show: {
            handler: function (val) {
                if (val) {
                    this.getTypeOptions();
                    this.ruleFormChild = {
                        type: '',
                        allocate_info: null,
                        app_money: undefined,
                        app_object: '',
                        app_data: '',
                        remark: '',
                        app_file_ids: []
                    };
                    if (this.$refs.ruleFormChild) {
                        this.$refs.ruleFormChild.resetFields();
                    }
                }
            },
            immediate: true
        },
        mark: {
            handler: function (val) {
                this.show = !!val;
            },
            immediate: true
        }
    }
};
</script>

<style lang="less">
.add_payment_popover {
    .file_box {
        /*.el-form-item__content{
            max-height:80px;
            overflow-y: overlay;
        }*/

        .file {
            flex: 0 0 40px;
        }
    }
}

.allocate_type_select_popper {
    .allocate_type_option {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
    }

    .option_label {
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .option_delete {
        flex: 0 0 auto;
        color: #c0c4cc;
        font-size: 14px;
        cursor: pointer;
    }

    .option_delete:hover {
        color: #f56c6c;
    }
}
</style>
